(() => {
  const KEY = "wishlist_handles";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch { return []; }
  };

  const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

  const has = (handle) => read().includes(handle);

  const toggle = (handle) => {
    const list = read();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.push(handle);
    write(list);
    return list.includes(handle);
  };

  const setUI = (el, active) => {
    el.setAttribute("aria-pressed", active ? "true" : "false");
    el.classList.toggle("is-active", active);
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;

    const active = toggle(handle);
    setUI(btn, active);
  });

  // initialise all buttons on page
  const init = () => {
    document.querySelectorAll("[data-wishlist-toggle]").forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");
      if (!handle) return;
      setUI(btn, has(handle));
    });
  };

  document.addEventListener("DOMContentLoaded", init);

  // for load-more / infinite-scroll appended products
  window.WishlistInit = init;
})();
